import XLight from '@/assets/xLight.svg';
import ArrowRightLight from '@/assets/arrowRightLight.svg';
import Modal from '@/components/general/Modal';
import type { AnalyticsBuilderReportData } from '@/types';
import AnalyticsBuilderReportContent from './AnalyticsBuilderReportContent';

type AnalyticsBuilderReportModalProps = {
  open: boolean;
  reportData: AnalyticsBuilderReportData | null;
  onClose: () => void;
  onBack: () => void;
  onExport: () => void;
};

const AnalyticsBuilderReportModal = ({
  open,
  reportData,
  onClose,
  onBack,
  onExport,
}: AnalyticsBuilderReportModalProps) => {
  if (!reportData) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableCloseOnBackdropClick
      contanerClassName="max-h-[92vh] w-full max-w-11/12 xl:max-w-[1400px] overflow-hidden bg-white shadow-2xl"
    >
      <div className="flex items-center justify-between border-b border-zinc-100 px-6 py-5">
        <div className="flex items-center gap-3">
          <button onClick={onBack} className="btn icon">
            <ArrowRightLight className="h-7 w-7 rotate-180" />
          </button>
          <div>
            <p className="text-xs font-semibold tracking-wide text-zinc-500 uppercase">Research ready</p>
            <h2 className="text-xl font-semibold text-zinc-950">{reportData.displayName}</h2>
          </div>
        </div>
        <button onClick={onClose} className="btn icon">
          <XLight className="h-7 w-7" />
        </button>
      </div>

      <AnalyticsBuilderReportContent reportData={reportData} onExport={onExport} />
    </Modal>
  );
};

export default AnalyticsBuilderReportModal;
